import axios from '../axios'

export const selectByPage = (data) => {
    return axios({
        url: '/admin/appletFunction/selectByPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/admin/appletFunction/insert',
        method: 'post',
        data
    })
}

export const update = (data) => {
    return axios({
        url: '/admin/appletFunction/update',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/admin/appletFunction/batchEnable',
        method: 'post',
        data
    })
}

export const batchDisabled = (data) => {
    return axios({
        url: '/admin/appletFunction/batchDisable',
        method: 'post',
        data
    })
}

export const selectByFlag = (params) => {
    return axios({
        url: '/admin/appletFunction/selectByFlag',
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/function.js